/// <amd-module name="Feed/Legacy/WebApi/VSS.CustomFeed.Contracts" />
import * as VSS_Feed_Contracts from "Feed/Common/Contracts/Feed";
import { WebPageConstants } from "Feed/Common/Contracts/WebPage";
import * as PackageResources from "Feed/Common/Resources";

export interface Feed extends VSS_Feed_Contracts.Feed {
    upstreamSource: VSS_Feed_Contracts.UpstreamSource;
    retentionPolicy?: VSS_Feed_Contracts.FeedRetentionPolicy;
}

/**
 * Extract the project id from a feed. Returns null for org-scoped feeds
 * @param feed The feed from which to extract any project id
 */
export function projId(feed: Feed) {
    return feed.project ? feed.project.id : null;
}

export interface MinimalPackageVersion extends VSS_Feed_Contracts.MinimalPackageVersion {
    index?: number;
}

export let UpstreamSource_All: VSS_Feed_Contracts.UpstreamSource = {
    id: null,
    location: "",
    displayLocation: "",
    name: PackageResources.UpstreamSourceKey_All,
    protocol: "any",
    deletedDate: null,
    upstreamSourceType: null,
    internalUpstreamCollectionId: null,
    internalUpstreamProjectId: null,
    internalUpstreamFeedId: null,
    internalUpstreamViewId: null,
    status: null,
    statusDetails: null,
    serviceEndpointId: null,
    serviceEndpointProjectId:null
};

export let UpstreamSource_Local: VSS_Feed_Contracts.UpstreamSource = {
    id: WebPageConstants.DirectUpstreamSourceIdForThisFeedFilter,
    location: "",
    displayLocation: "",
    name: PackageResources.UpstreamSourceKey_Local,
    protocol: "any",
    deletedDate: null,
    upstreamSourceType: null,
    internalUpstreamCollectionId: null,
    internalUpstreamProjectId: null,
    internalUpstreamFeedId: null,
    internalUpstreamViewId: null,
    status: null,
    statusDetails: null,
    serviceEndpointId: null,
    serviceEndpointProjectId: null
};

export interface ExtendedUpstreamSource extends VSS_Feed_Contracts.UpstreamSource {
    isCustom?: boolean;
    useServiceEndpoint?: boolean;
}
